/* ARMORED SKIN — customizer conectado a variantes reales de Shopify */
(function () {
  "use strict";
  var stage = document.getElementById("czStage");
  if (!stage) return;

  var dataEl = document.getElementById("czData");
  var CFG = null;
  if (dataEl) { try { CFG = JSON.parse(dataEl.textContent); } catch (e) { CFG = null; } }

  function vopts(v) { return v.options || [v.option1, v.option2, v.option3]; }
  var fmt = window.ASmoney || function (c) { return (c / 100).toFixed(2).replace(".", ",") + "€"; };
  var POS_LABEL = { pecho: "Pecho", espalda: "Espalda", homizq: "Hombro izq.", homder: "Hombro der." };

  // ---- derive option structure from the product ----
  var typeIdx = 0, sizeIdx = 1, colorIdx = 2;
  var types = [], sizes = [], colors = [];
  var feePrice = 0;
  if (CFG && CFG.product) {
    var P = CFG.product;
    var names = P.options.map(function (n) { return (n.name || n).toString().toLowerCase(); });
    function idxOf(want, fallback) {
      var i = names.indexOf((want || "").toLowerCase());
      return i >= 0 ? i : fallback;
    }
    typeIdx = idxOf(CFG.typeOption, 0);
    sizeIdx = idxOf(CFG.sizeOption, 1);
    colorIdx = idxOf(CFG.colorOption, 2);
    function uniqueValues(i) {
      var seen = [];
      P.variants.forEach(function (v) { var val = vopts(v)[i]; if (val && seen.indexOf(val) === -1) seen.push(val); });
      return seen;
    }
    types = uniqueValues(typeIdx);
    sizes = P.options[sizeIdx] ? uniqueValues(sizeIdx) : ["U"];
    colors = P.options[colorIdx] ? uniqueValues(colorIdx) : [];
    feePrice = CFG.fee ? CFG.fee.price : 0;
  }

  // demo fallback so the section still previews without a product
  var DEMO = !CFG || !CFG.product;
  if (DEMO) {
    types = ["Camiseta básica", "Premium", "Técnica Dry", "Sudadera"];
    sizes = ["S", "M", "L", "XL", "XXL"];
    feePrice = 450;
  }
  var DEMO_PRICES = { "Camiseta básica": 1490, "Premium": 2290, "Técnica Dry": 2790, "Sudadera": 3490 };

  var S = { type: types[0], size: sizes.indexOf("M") >= 0 ? "M" : sizes[0], color: null, pos: ["pecho"], qty: 1, side: "front" };
  var imgData = null, imgFile = null;

  // ---- helpers ----
  function minPriceForType(t) {
    if (DEMO) return DEMO_PRICES[t] || 1490;
    var min = null;
    CFG.product.variants.forEach(function (v) {
      if (vopts(v)[typeIdx] === t && (min === null || v.price < min)) min = v.price;
    });
    return min || 0;
  }
  function findVariant() {
    if (DEMO) return null;
    return CFG.product.variants.find(function (v) {
      var o = vopts(v);
      var okT = o[typeIdx] === S.type;
      var okS = !CFG.product.options[sizeIdx] || o[sizeIdx] === S.size;
      var okC = !S.color || !CFG.product.options[colorIdx] || o[colorIdx] === S.color.name;
      return okT && okS && okC;
    });
  }
  function unitBase() {
    var v = findVariant();
    if (v) return v.price;
    return minPriceForType(S.type) + (S.size === "XXL" ? 200 : 0);
  }
  function volPct(q) {
    var tiers = (CFG && CFG.volumeTiers) || [{ min: 25, pct: 0.15 }, { min: 10, pct: 0.10 }];
    for (var i = 0; i < tiers.length; i++) if (q >= tiers[i].min) return tiers[i].pct;
    return 0;
  }

  // ---- build type & size buttons ----
  var typeBox = document.getElementById("czType");
  var sizeBox = document.getElementById("czSize");
  typeBox.innerHTML = types.map(function (t) {
    return '<button type="button" class="cz-chip' + (t === S.type ? " active" : "") + '" data-type="' + t + '">' + t + " <small>" + fmt(minPriceForType(t)) + "</small></button>";
  }).join("");
  sizeBox.innerHTML = sizes.map(function (s) {
    return '<button type="button" class="cz-size' + (s === S.size ? " active" : "") + '" data-size="' + s + '">' + s + "</button>";
  }).join("");
  var posPriceEl = document.getElementById("czPosPrice");
  if (posPriceEl && feePrice) posPriceEl.textContent = "+" + fmt(feePrice) + " c/u";

  // colors: first swatch active
  var colorBox = document.getElementById("czColor");
  var firstSw = colorBox.querySelector(".cz-sw");
  if (firstSw) S.color = { hex: firstSw.dataset.color, name: firstSw.dataset.name };

  // ---- rendering ----
  var teeShape = stage.querySelector(".cz-tee-shape");
  var zones = Array.prototype.slice.call(stage.querySelectorAll(".cz-zone"));
  var sideBadge = document.getElementById("czSideBadge");
  function setActive(box, attr, val) {
    box.querySelectorAll("button[" + attr + "]").forEach(function (b) {
      b.classList.toggle("active", b.getAttribute(attr) === val);
    });
  }
  function renderPreview() {
    if (S.color) teeShape.style.fill = S.color.hex;
    stage.dataset.side = S.side;
    if (sideBadge) sideBadge.textContent = S.side === "front" ? "Frente" : "Espalda";
    colorBox.querySelectorAll(".cz-sw").forEach(function (b) {
      b.classList.toggle("active", S.color && b.dataset.color === S.color.hex);
    });
    document.querySelectorAll(".cz-side-toggle button").forEach(function (b) {
      b.classList.toggle("active", b.dataset.side === S.side);
    });
    zones.forEach(function (z) {
      var on = S.pos.indexOf(z.dataset.pos) >= 0;
      z.classList.toggle("on", on);
      var img = z.querySelector("img");
      if (on && imgData) { img.src = imgData; z.classList.add("has-img"); }
      else { z.classList.remove("has-img"); img.removeAttribute("src"); }
    });
  }
  function renderCalc() {
    var nPos = S.pos.length;
    var base = unitBase();
    var posCost = nPos * feePrice;
    var unit = base + posCost;
    var qty = Math.max(1, S.qty | 0);
    var gross = unit * qty;
    var pct = volPct(qty);
    var disc = Math.round(gross * pct);
    var total = gross - disc;

    document.getElementById("czSummaryName").textContent =
      S.type + (S.color ? " · " + S.color.name : "") + " · Talla " + S.size;

    var rows = [];
    rows.push('<div class="cz-brow"><dt>' + S.type + ' <small>· talla ' + S.size + "</small></dt><dd>" + fmt(base) + "</dd></div>");
    if (nPos) rows.push('<div class="cz-brow"><dt>Estampados <small>· ' + nPos + " × " + fmt(feePrice) + "</small></dt><dd>+" + fmt(posCost) + "</dd></div>");
    else rows.push('<div class="cz-brow muted"><dt>Estampados <small>· elige una posición</small></dt><dd>' + fmt(0) + "</dd></div>");
    rows.push('<div class="cz-brow"><dt>Diseño / imagen propia</dt><dd>' + (imgData ? "Incluido" : "—") + "</dd></div>");
    if (pct) rows.push('<div class="cz-brow disc"><dt>Descuento volumen <small>· ' + qty + " uds.</small></dt><dd>−" + fmt(disc) + "</dd></div>");
    document.getElementById("czBreakdown").innerHTML = rows.join("");

    document.getElementById("czUnit").textContent = fmt(unit);
    document.getElementById("czTotal").textContent = fmt(total);
    document.getElementById("czTotalQty").textContent = qty === 1 ? "1 unidad" : qty + " unidades";

    var hint = document.getElementById("czVolHint");
    if (hint) {
      if (qty >= 25) hint.textContent = "−15% estimado (se aplica en el checkout)";
      else if (qty >= 10) hint.textContent = "−10% estimado · 25+ = −15%";
      else hint.textContent = "Desde 10 uds. −10%";
    }
    var v = findVariant();
    var add = document.getElementById("czAdd");
    if (add && !DEMO) {
      add.disabled = !v || !v.available;
      if (v && !v.available) add.textContent = "Combinación agotada";
    }
  }
  function renderAll() { renderPreview(); renderCalc(); }

  // ---- events ----
  typeBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-type]"); if (!b) return;
    S.type = b.dataset.type; setActive(typeBox, "data-type", S.type); renderCalc();
  });
  sizeBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-size]"); if (!b) return;
    S.size = b.dataset.size; setActive(sizeBox, "data-size", S.size); renderCalc();
  });
  colorBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-color]"); if (!b) return;
    S.color = { hex: b.dataset.color, name: b.dataset.name }; renderAll();
  });
  function togglePos(pos) {
    var i = S.pos.indexOf(pos);
    if (i >= 0) S.pos.splice(i, 1); else S.pos.push(pos);
    document.getElementById("czPos").querySelectorAll(".cz-pos-btn").forEach(function (b) {
      b.classList.toggle("active", S.pos.indexOf(b.dataset.pos) >= 0);
    });
    if (S.pos.indexOf(pos) >= 0) S.side = pos === "espalda" ? "back" : "front";
    renderAll();
  }
  document.getElementById("czPos").addEventListener("click", function (e) {
    var b = e.target.closest(".cz-pos-btn"); if (!b) return; togglePos(b.dataset.pos);
  });
  zones.forEach(function (z) { z.addEventListener("click", function () { togglePos(z.dataset.pos); }); });
  document.querySelector(".cz-side-toggle").addEventListener("click", function (e) {
    var b = e.target.closest("[data-side]"); if (!b) return; S.side = b.dataset.side; renderPreview();
  });
  function setQty(v) {
    S.qty = Math.min(999, Math.max(1, v | 0 || 1));
    document.getElementById("czQty").value = S.qty; renderCalc();
  }
  document.getElementById("czMinus").addEventListener("click", function () { setQty(S.qty - 1); });
  document.getElementById("czPlus").addEventListener("click", function () { setQty(S.qty + 1); });
  document.getElementById("czQty").addEventListener("input", function () { setQty(parseInt(this.value, 10)); });

  // ---- image upload ----
  var fileInput = document.getElementById("czFile");
  var uploadBox = document.getElementById("czUpload");
  function handleFile(file) {
    if (!file || !/^image\//.test(file.type)) return;
    imgFile = file;
    var reader = new FileReader();
    reader.onload = function () {
      imgData = reader.result;
      document.getElementById("czThumb").src = imgData;
      document.getElementById("czFileName").textContent = file.name;
      document.getElementById("czUploadEmpty").hidden = true;
      document.getElementById("czUploadDone").hidden = false;
      renderAll();
    };
    reader.readAsDataURL(file);
  }
  fileInput.addEventListener("change", function (e) { handleFile(e.target.files[0]); });
  document.getElementById("czClear").addEventListener("click", function (e) {
    e.preventDefault(); e.stopPropagation();
    imgData = null; imgFile = null; fileInput.value = "";
    document.getElementById("czUploadEmpty").hidden = false;
    document.getElementById("czUploadDone").hidden = true;
    renderAll();
  });
  ["dragenter", "dragover"].forEach(function (ev) {
    uploadBox.addEventListener(ev, function (e) { e.preventDefault(); uploadBox.classList.add("drag"); });
  });
  ["dragleave", "drop"].forEach(function (ev) {
    uploadBox.addEventListener(ev, function (e) { e.preventDefault(); uploadBox.classList.remove("drag"); });
  });
  uploadBox.addEventListener("drop", function (e) { if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });

  // ---- add to cart ----
  document.getElementById("czAdd").addEventListener("click", function () {
    var btn = this;
    if (DEMO) return;
    if (!S.pos.length) {
      window.AStoast("Elige al menos una posición", "Personalización");
      return;
    }
    var v = findVariant();
    if (!v || !v.available) { window.AStoast("Combinación no disponible", "Personalización"); return; }
    var qty = Math.max(1, S.qty | 0);
    var posNames = S.pos.map(function (p) { return POS_LABEL[p]; }).join(", ");

    btn.disabled = true;
    var fd = new FormData();
    fd.append("id", v.id);
    fd.append("quantity", qty);
    fd.append("properties[Posiciones]", posNames);
    if (imgFile) fd.append("properties[Diseño]", imgFile, imgFile.name);
    fd.append("properties[_customizer]", "1");

    fetch((window.AS && window.AS.routes.cartAdd || "/cart/add") + ".js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (x) { throw new Error(x.description || "Error al añadir"); });
        return r.json();
      })
      .then(function () {
        // add print fee lines (one per position per unit)
        if (CFG.fee && S.pos.length) {
          return window.ASaddVariant(CFG.fee.variantId, S.pos.length * qty, { "Para": S.type + " personalizada (" + posNames + ")" });
        }
      })
      .then(function () {
        window.AStoast(S.type + " personalizada", "Añadido al carrito");
        return window.ASrefreshCart(true);
      })
      .catch(function (err) { window.AStoast(err.message, "No se pudo añadir"); })
      .finally(function () { btn.disabled = false; });
  });

  renderAll();
})();
